import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

import styles from './LeavePromptModal.module.less';

const LeavePromptModal = ({ hideModalFn, variant, callback }) => {
  return (
    <div className={styles.leavePromptModalContainer}>
      <h4 className={styles.header}>Leave without saving changes?</h4>
      <p>Any edits made to your event details will be lost.</p>
      <div className={styles.buttonContainer}>
        <ButtonV2 variant="danger" onClick={callback}>
          Yes, {variant === 'discard' ? 'Discard' : 'Delete'} Changes
        </ButtonV2>
        <ButtonV2 variant="secondary" onClick={hideModalFn} className={styles.buttonPadding}>
          Cancel
        </ButtonV2>
      </div>
    </div>
  );
};

LeavePromptModal.propTypes = {
  hideModalFn: PropTypes.func,
  variant: PropTypes.oneOf(['discard', 'delete']),
  callback: PropTypes.func,
};

export default LeavePromptModal;



// WEBPACK FOOTER //
// ./src/pages/Events/LeavePromptModal/LeavePromptModal.jsx